import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useURLInit({ setMessage, setCreatingNewAgent, setSelectedAgentId, setAgentDetail }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasPrefilled = useRef(false);
  const hasOnboardingPrefilled = useRef(false);

  const onboardingMode = searchParams.get('onboarding') === '1';
  const onboardingStartNew = searchParams.get('new') === '1';

  // Pre-fill message from URL params (taskId, policyId)
  useEffect(() => {
    const taskId = searchParams.get('taskId');
    const policyId = searchParams.get('policyId');

    if (taskId && !hasPrefilled.current) {
      hasPrefilled.current = true;
      const prefillMessage = policyId
        ? `Investigate @task:${taskId} under @policy:${policyId}`
        : `Investigate @task:${taskId}`;
      setMessage(prefillMessage);
      setCreatingNewAgent(true);
      setSelectedAgentId(null);
      setAgentDetail(null);

      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams, setMessage, setCreatingNewAgent, setSelectedAgentId, setAgentDetail]);

  // Onboarding auto-create
  useEffect(() => {
    if (!onboardingMode || !onboardingStartNew || hasOnboardingPrefilled.current) return;

    hasOnboardingPrefilled.current = true;
    setCreatingNewAgent(true);
    setSelectedAgentId(null);
    setAgentDetail(null);
    setMessage((previousMessage) => (
      previousMessage
      || 'I am creating my first policy. I will upload an example document, then help me define the fields and flow.'
    ));

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete('new');
    setSearchParams(nextSearchParams, { replace: true });
  }, [onboardingMode, onboardingStartNew, searchParams, setSearchParams, setMessage, setCreatingNewAgent, setSelectedAgentId, setAgentDetail]);

  return { onboardingMode, onboardingStartNew };
}
